/* eslint-disable */
// assets
import { IconCash, IconPlus, IconList, IconHistory } from '@tabler/icons';

// constant
const icons = {
    IconCash,
    IconPlus,
    IconList,
    IconHistory
};

// ==============================|| PAYOUT MENU ITEMS ||============================== //

const Payout = {
    id: 'payout',
    title: 'Payout',
    type: 'group',
    children: [
        {
            id: 'payout-collapse',
            title: 'Payout',
            type: 'collapse',
            icon: icons.IconCash,
            children: [
                {
                    id: 'payout-add',
                    title: 'Add',
                    type: 'item',
                    url: '/payout/add-beneficiary',
                    icon: icons.IconPlus,
                    breadcrumbs: false
                },
                {
                    id: 'payout-list',
                    title: 'List',
                    type: 'item',
                    url: '/payout/list',
                    icon: icons.IconList,
                    breadcrumbs: false
                },
                {
                    id: 'payout-transfer',
                    title: 'Transfer',
                    type: 'item',
                    url: '/payout/transfer',
                    icon: icons.IconCash,
                    breadcrumbs: false
                },
                {
                    id: 'payout-history',
                    title: 'History',
                    type: 'item',
                    url: '/payout/transfer-history',
                    icon: icons.IconHistory,
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default Payout;
